import { Box, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, FormErrorMessage, useDisclosure, Modal, ModalOverlay, ModalBody, ModalContent, PinInput, PinInputField, ModalCloseButton, } from "@chakra-ui/react";
import { useState } from "react";
import IdentityDetailLogo from "../../../../../assets/images/IdentityDetailLogo.svg";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { EmployeePersonalInfo } from "./modal";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { AlertCard, CustomToast } from "../../../../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Identity } from "./modal";
import { useAuth } from "../../../../../hooks/useAuth";

interface Props {
    employeeId: number | null;
    personalDetail?: EmployeePersonalInfo;
    reload: () => void;
}

export interface IIdentity {
    empId?: number | null;
    aadhar_Number: string;
    pan_Number: string;
};

const IdentityDetails = ({ employeeId, personalDetail, reload }: Props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const { hasPermission, loginObj } = useAuth();
    const loggedInEmpId = loginObj?.employeeId;
    const canViewOthers = hasPermission("Employee", "showCriticalField");
    const isOwnProfile = loggedInEmpId === employeeId;
    const [alertConfig, setAlertConfig] = useState<{ description: string; colorScheme: string; onConfirm: () => void; } | null>(null);
    const [sendOtp, setSendOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpbox, setOtpbox] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const canEditIdentity =  hasPermission("Employee", "UpdateIdentityDetail") && hasPermission("Employee", "showCriticalField");

    const IdentityDetailsSchema: any = yup.object().shape({
        aadhar_Number: yup
            .string()
            .required("Aadhaar Number is required")
            .matches(/^\d{4}\s\d{4}\s\d{4}$/, "Aadhaar Number must be in XXXX XXXX XXXX format."),
        pan_Number: yup
            .string()
            .required("PAN Number is required.")
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "PAN Number must be a valid 10-character format (e.g., ABCDE1234F)."),
    })

    const { control, handleSubmit, register, formState: { errors, isSubmitting }, reset } = useForm<IIdentity>({
        resolver: yupResolver(IdentityDetailsSchema),
        defaultValues: {
            aadhar_Number: formatAadhaar(personalDetail?.aadhar_Number),
            pan_Number: personalDetail?.pan_Number || "",
        },
    });

    function formatAadhaar(value?: string) {
        if (!value) return "";
        const digits = String(value).replace(/\D/g, "").slice(0, 12);
        return digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
    }

    function handleEditClick() {
        reset({
            aadhar_Number: formatAadhaar(personalDetail?.aadhar_Number),
            pan_Number: personalDetail?.pan_Number,
        });
        onOpen();
    }

    const onSubmit = async (data: IIdentity) => {
        data.empId = employeeId;
        data.aadhar_Number = data.aadhar_Number.replace(/\s/g, "");
        let endpoint = `Hrlense_Employee/personalDetail/${employeeId}`;
        const response = await fetchApi(endpoint, "PUT", data, null, "Identity Details Updated");
        if (response) {
            reload();
            onClose();
        }
    }


    const getDisplayValue = (key: string, value?: string) => {
        if (!value) return "-";
        if (canViewOthers) {
            return value;
        }
        if (isOwnProfile && otpVerified) {
            return value;
        }
        if (isOwnProfile) {
            if (key === "aadhar_Number") {
                return "XXXX XXXX " + value.replace(/\D/g, "").slice(-4);
            }
            if (key === "pan_Number") {
                return "XXXXX" + value.slice(-5);
            }
        }
        return "********";
    };


    const sendOtpforIdentity = async () => {
        setSendOtp(true);
        const res = await fetchApi("Tds_Slab/otpforsecure","POST",
          { employee_Id: employeeId,purpose: "Identity Details" },
            null,"" );
        if (res) {
            setSendOtp(false);
            setOtpbox(true);
            addToast({ message: res.message, status: "success" });
        }
        if (!res) {
            setSendOtp(false);
            onClose();         
           
        }
    };

    const verifyOtp = async () => {
        if (otp.length !== 6) {
            addToast({ message: "Enter 6 digit Verification Code", status: "error" });
            return;
        }
        setVerifying(true);
        const res = await fetchApi("Tds_Slab/verifyotp","POST",
            { purpose: "Identity Details", otp }
        );
        if (res) { setVerifying(false); setOtpbox(false);setOtpVerified(true); setOtp(""); addToast({ message: res.message, status: "success" }); }
        if (!res) { setVerifying(false); setOtp("");  }
    };
    return (
        <>

            <Box pt={2} mb={6} className="main">
                <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                    <Flex align="center" gap={3}>
                        <Image src={IdentityDetailLogo} alt={"Benifits & ID Numberss"} />
                        <Text className="font-poppins text_sm text_medium col">
                            Identity Details
                        </Text>
                    </Flex>

                    <Flex align="center" gap={2}>
                        {/* NEW → View Button */}
                        {!canViewOthers && isOwnProfile && !otpVerified && (
                            <Button
                                size="xs"
                                variant="link"
                                colorScheme="blue"
                                onClick={() =>
                                    setAlertConfig({
                                        
                                       description: "For security purposes, a verification code is required to access full details. Proceed to receive the code?",
                                        colorScheme: "green",
                                        onConfirm: () => sendOtpforIdentity(),
                                    })                                   
                                }                                
                            >
                                View
                            </Button>
                        )}

                        {canEditIdentity && (
                            <IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={handleEditClick} />
                        )}
                    </Flex>
                </Flex>

                <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                    {Identity.map((item, index) => {
                        const rawValue: any = personalDetail?.[item.key];
                        const displayValue = getDisplayValue(item.key, rawValue);

                        return (
                           <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={2}>
                                <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)"   whiteSpace="nowrap">
                                    {item?.label}
                                </Text>
                                <Text className="font-poppins text_sm text_medium "  wordBreak="break-word">
                                    {displayValue}
                                </Text>
                            </Grid>
                        );
                    })}
                </Box>
            </Box>
            <AlertCard
                isLoading={sendOtp} isOpen={!!alertConfig} title="Access Confirmation" onClose={() => setAlertConfig(null)} onConfirm={() => { if (alertConfig?.onConfirm) alertConfig.onConfirm(); setAlertConfig(null); }} description={alertConfig?.description || ''} colorScheme={alertConfig?.colorScheme || 'red'}
            />
            {/* Model for OTP*/}
            <Modal isOpen={otpbox} onClose={() => setOtpbox(false)} closeOnOverlayClick={false} closeOnEsc={false} isCentered>
                <ModalOverlay />
                <ModalContent borderRadius="12px" p={6}>   
                     <ModalCloseButton />              
                    <ModalBody textAlign="center">
                        <Text fontSize="xl" fontWeight="600" mb={2}> OTP Verification </Text>
                        <Text color="gray.500" mb={6}>
                           Please enter the 6-digit verification code sent to your registered official email address.
                        </Text>

                        <Flex justify="center" gap={3} mb={6}>
                            <PinInput otp value={otp} onChange={setOtp}>
                                {[...Array(6)].map((_, i) => (
                                    <PinInputField key={i} />
                                ))}
                            </PinInput>
                        </Flex>
                        <Button isDisabled={verifying} width="100%" colorScheme="green" onClick={verifyOtp} >
                            Verify Code
                        </Button>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* Drawer for editing */}
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Update Identity Details</DrawerHeader>
                    <DrawerBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormControl isInvalid={!!errors.aadhar_Number} mb={4}>
                                <FormLabel> Aadhaar Number </FormLabel>
                                <Controller
                                    name="aadhar_Number" control={control}
                                    render={({ field }) => (
                                        <Input type="text"  {...field}
                                            onChange={(e) => {
                                                let val = e.target.value.replace(/\D/g, "").slice(0, 12); // only numbers, max 12
                                                val = val.replace(/(\d{4})(?=\d)/g, "$1 "); // add space every 4 digits
                                                field.onChange(val.trim());
                                            }}
                                        />
                                    )}
                                />
                                <FormErrorMessage>{errors.aadhar_Number?.message}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={!!errors.pan_Number} mb={4}>
                                <FormLabel> PAN Number </FormLabel>
                                <Controller
                                    name="pan_Number" control={control}
                                    render={({ field }) => (
                                        <Input type="text"  {...field}
                                            onChange={(e) => {
                                                const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
                                                field.onChange(val);
                                            }}
                                        />
                                    )}
                                />
                                <FormErrorMessage>{errors.pan_Number?.message}</FormErrorMessage>
                            </FormControl>

                            <Box mt={6} textAlign="right">
                                <Button type="submit" className="btn_theme btn_theme:hover" isLoading={isSubmitting}>
                                    Update
                                </Button>
                            </Box>
                        </form>

                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>

    );
};

export default IdentityDetails;